import QueryString from 'qs';
import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { handlePostMessage } from '../js/postMessage';

export default function NaverClose() {
  const location = useLocation();
  const handleClose = () => {
    window.close();
  };
  useEffect(() => {
    const query = QueryString.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    //@ts-ignore
    if (query.app === 'true') {
      // goBack();
      handlePostMessage({ actionType: 'goBack' });
      return;
    } else {
      const closeButton = document.createElement('button');
      closeButton.style.display = 'none'; // 버튼을 보이지 않게 숨김
      closeButton.onclick = () => {
        handleClose();
      };
      document.body.appendChild(closeButton);

      // 버튼 클릭 이벤트 시뮬레이션
      closeButton.click();
    }
  }, [location]);
  return <div className="main_wrap"></div>;
}
